import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddSubDeptModal = ({ isAddOpen, onAddClose, formData, setFormData, fetchData, user, branch, branches }) => {
  if (!isAddOpen) return null;


  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
  e.preventDefault();

  // === Validation: Sub Dept Code ===
  if (!formData.code || formData.code.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Sub Department Code should not be empty.",
    });
    return;
  }

  // === Validation: Sub Dept Name ===
  if (!formData.name || formData.name.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Sub Department Name should not be empty.",
    });
    return;
  }

  // === Validation: Branch ===
  if (!formData.branches || formData.branches.trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Branch should be selected.",
    });
    return;
  }

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      `https://rfs2.infraconsoft.net.in/api/subDept_insert`,
      {
        code: formData.code,
        name: formData.name,
        user: user,
        branch: formData.branches,
      }
    );

    if (response.data.success) {
      Swal.fire({
        icon: "success",
        title: "Inserted!",
        text: "Sub Department inserted successfully.",
      });

       setFormData({
          name: "",
          user,
          branch,
        });
      onAddClose();
      fetchData();
    }
  } catch (error) {
    console.error("Error inserting Sub department:", error);

    if (error.response && error.response.data && error.response.data.message) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Insert failed. Please try again.",
      });
    }
  }
};

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }} >
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onAddClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Add New Sub Department</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

        <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <select name="branches"  value={formData.branches}  onChange={handleEditChange} required  >
            <option value="">Select Branch</option>
            {branches.map((item) => (
              <option key={item.branchMaster_code} value={item.branchMaster_code}>
                {item.branchMaster_name}
              </option>
            ))}
          </select>
              </div>
            </div>

          <div className="form-row">
              <div className="form-group">
                <label>Sub Department Code :</label>
                <input type="text" name="code" value={formData.code} onChange={handleEditChange} placeholder="Enter Your Sub Code.."/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Sub Department Name :</label>
                <input type="text" name="name" value={formData.name} onChange={handleEditChange} placeholder="Enter Your Sub Name.."/>
              </div>
              
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Submit
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default AddSubDeptModal;
